import Vue from 'vue'

import modalWindow from './src/modal-window.vue';

Vue.component('modal-window', modalWindow);

export default modalWindow;



//////////////////
// WEBPACK FOOTER
// ./~/modal-window/index.js
// module id = 405
// module chunks = 0